import { Link } from "react-router-dom";
import { homeCategories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">蜜桃成熟时电影</span>
            </div>
            <p className="text-sm leading-7 text-background-300">
              一个专注高清电影资源展示与剧情介绍的内容平台，为电影爱好者梳理每部作品的看点、剧情与推荐，
              帮助你高效发现想看的电影。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" aria-label="微博" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer text-background-200">
                <i className="ri-weibo-fill"></i>
              </a>
              <a href="#" aria-label="微信" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer text-background-200">
                <i className="ri-wechat-fill"></i>
              </a>
              <a href="#" aria-label="哔哩哔哩" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer text-background-200">
                <i className="ri-bilibili-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4 text-sm">
              <Link to="/category" className="hover:text-primary-300 transition-colors cursor-pointer">电影分类</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {homeCategories.slice(0, 5).map((c) => (
                <li key={c.name}>
                  <Link
                    to={`/category?genre=${encodeURIComponent(c.name)}`}
                    className="text-background-300 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {c.name}片
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4 text-sm">
              <Link to="/about" className="hover:text-primary-300 transition-colors cursor-pointer">关于本站</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-300 hover:text-accent-300 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/search" className="text-background-300 hover:text-accent-300 transition-colors cursor-pointer">搜索电影</Link></li>
              <li><Link to="/about" className="text-background-300 hover:text-accent-300 transition-colors cursor-pointer">联系方式</Link></li>
              <li><span className="text-background-400">本站为演示内容站</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 蜜桃成熟时电影 · 保留所有权利</p>
          <p>本站内容均为演示数据，不含播放、下载、会员及支付功能</p>
        </div>
      </div>
    </footer>
  );
}